import React, {useContext} from 'react';
import {bool, object} from 'prop-types';
import cx from 'classnames';
import Button from '../button';
import {FormContext} from '../form';
import {FormStepContext} from '../form-step';
import If from '../../misc/If';
import {ARE_KEYBOARD_SHORTCUTS_ENABLED} from '../../../constant/Application';

import './FormNavigation.css';

const propTypes = {
  isCentered : bool,
  style      : object
};

const defaultProps = {
  isCentered : false,
  style      : {}
};

function FormNavigation(props) {
  const {isCentered, style} = props;
  const {nextButtonProps} = useContext(FormContext);
  const {handleOnGoNext} = useContext(FormStepContext);
  const {text, hasIcon} = nextButtonProps;

  return (
    <footer
      className={cx('form-navigation', {
        'form-navigation--is-centerd' : isCentered
      })}
      style={style}
    >
      <Button className="form-navigation__button" onClick={handleOnGoNext}>
        {text}

        {hasIcon && (
          <svg className="form-navigation__button__icon" height="13" width="16">
            <path d="M14.293.293l1.414 1.414L5 12.414.293 7.707l1.414-1.414L5 9.586z" fill="currentColor" />
          </svg>
        )}
      </Button>

      <If condition={ARE_KEYBOARD_SHORTCUTS_ENABLED}>
        <div className="form-navigation__hot-key-hint">
          press

          <strong className="form-navigation__hot-key-hint__em">
            Enter {'\u21B5'}
          </strong>
        </div>
      </If>
    </footer>
  );
}

FormNavigation.propTypes = propTypes;
FormNavigation.defaultProps = defaultProps;

export default FormNavigation;
